/*
  Header reveal on scroll — hides on scroll down, returns on scroll up.

  Rules, from README section 2:
    - always visible in the top ~80px, regardless of direction
    - hides only after >10px of downward scroll, so a trackpad does not twitch it
    - returns on ANY upward scroll, immediately, with no threshold
    - never hides while a drawer is open, or while something inside the header
      has focus — a keyboard user tabbing the nav must not lose it
    - under prefers-reduced-motion the class still toggles; the CSS drops the
      transition so it snaps rather than animates

  The transform and the transition live in gb-v3.css. This file decides when
  the class is on -- and, for the side menu, when the drawer is inert.

  The inert half lives here rather than in its own file because it asks the
  same question this script already answers: is a drawer open? The open-state
  class list below was read off the theme's own source, and duplicating it in
  a second file is how two copies drift apart.
*/
(function () {
  'use strict';

  var header = document.querySelector('.shopify-section-main-header');
  if (!header) return;

  var TOP_ZONE = 80;
  var DOWN_THRESHOLD = 10;
  var HIDDEN = 'gb-header-hidden';

  var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var downFrom = lastY;   // where the current downward run began
  var ticking = false;

  // Yuva sets these on <body> when a drawer opens. Hiding the header behind an
  // open menu or search would take the close control off screen with it.
  // Read off the theme's own source rather than guessed:
  //   nav-open          common.js:4191   the side menu / mobile nav
  //   side_Drawer_open  cart-ajax.js:703, common.js:2357, common.js:4359
  //                     cart drawer, quick view, pickup availability
  //   addsearch         search.js:54 toggles the value of the search anchor's
  //                     data-search-drawer, which header-icons.liquid sets to
  //                     "addsearch"
  //   hamburder-opened  common.js:3700   header2/4 overlay menu
  var OPEN_BODY_CLASSES = [
    'nav-open',
    'side_Drawer_open',
    'addsearch',
    'hamburder-opened'
  ];

  function drawerOpen() {
    for (var i = 0; i < OPEN_BODY_CLASSES.length; i++) {
      if (document.body.classList.contains(OPEN_BODY_CLASSES[i])) return true;
    }
    return false;
  }

  function focusInsideHeader() {
    var el = document.activeElement;
    return !!el && el !== document.body && header.contains(el);
  }

  function update() {
    ticking = false;

    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y < 0) y = 0;

    var delta = y - lastY;
    lastY = y;

    if (y <= TOP_ZONE || drawerOpen() || focusInsideHeader()) {
      header.classList.remove(HIDDEN);
      downFrom = y;
      return;
    }

    if (delta < 0) {
      // Any upward scroll, immediately, with no threshold.
      header.classList.remove(HIDDEN);
      downFrom = y;
      return;
    }

    // The threshold accumulates across frames since the last direction change.
    // Measured per frame it only ever tripped on a mouse-wheel notch: a slow
    // trackpad or a smooth-scroll animation moves 3-6px a frame and would
    // never have hidden the header at all.
    if (y - downFrom > DOWN_THRESHOLD) {
      header.classList.add(HIDDEN);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Tabbing into a hidden header must bring it back before focus lands.
  header.addEventListener('focusin', function () {
    header.classList.remove(HIDDEN);
  });

  /* ---- The closed side menu is inert ---------------------------------
     MEASURED before this: twelve of the first forty tab stops at 390px landed
     inside the closed, off-screen drawer, and the close carried tabindex="-1",
     so a keyboard visitor who opened it could not get out. `inert` removes the
     subtree from the tab order and the accessibility tree in one attribute.

     Only the side menu, not the four drawers drawerOpen() covers: the others
     are vendor components with their own markup, and inerting them from here
     would be a guess about lifecycles this script does not own. */
  var sideMenu = document.getElementById('mobileMenu');

  if (sideMenu) {
    var SIDE_MENU_CLASSES = ['nav-open', 'hamburder-opened'];

    function sideMenuOpen() {
      for (var i = 0; i < SIDE_MENU_CLASSES.length; i++) {
        if (document.body.classList.contains(SIDE_MENU_CLASSES[i])) return true;
      }
      // header.min.css also opens it from the hash alone, with no class.
      return window.location.hash === '#' + sideMenu.id;
    }

    var sideMenuWasOpen = null;

    function syncSideMenu() {
      var open = sideMenuOpen();
      if (open === sideMenuWasOpen) return;
      sideMenuWasOpen = open;

      if (!open) {
        sideMenu.setAttribute('inert', '');
        return;
      }

      sideMenu.removeAttribute('inert');
      // Focus the close first: it is the way out, and a visitor who opens the
      // drawer should reach it before the thirty links behind it.
      var close = sideMenu.querySelector('.close-btn');
      if (close) {
        // inert is removed synchronously, but the drawer is still translated
        // off-canvas this frame; focusing now would scroll to where it is not.
        window.requestAnimationFrame(function () { close.focus(); });
      }
    }

    syncSideMenu();
    window.addEventListener('hashchange', syncSideMenu);
    new MutationObserver(syncSideMenu)
      .observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
